import React from 'react'
import {Helmet} from "react-helmet"
import PlayMedia from '~/core/components/PlayMedia'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchStoryIfNeeded } from '~/news/actions'
import { DateTime } from 'luxon'

const Article = (props) => {
	const { story, stories } = props;
	var author, live, nid
	let author_id = story.uid[0].target_id
	if (stories.authors[author_id] && stories.authors[author_id][0]) {
		author = stories.authors[author_id][0]
	}
	if ( story.live_content && story.live_content[0] && story.live_content[0].value === true) {
		live = true;
		nid = story.nid[0].value;
	}
	var result = "<p>" + story.body[0].value + "</p>";
	result = result.replace(/\r\n\r\n/g, "</p><p>").replace(/\n\n/g, "</p><p>");
	result = result.replace(/\r\n/g, "<br />").replace(/\n/g, "<br />");
	var badmarkup = { __html: result  };

	return (
		<div className="section" key={story.nid[0].value}>
				<Helmet>
					<title>{story.title[0].value}</title>
					<meta name="description" content={story.body[0].summary ? story.body[0].summary :story.body[0].value.replace(/<[^>]+>/g, '').slice(0, 140) } />
					<meta name="og:description" content={story.body[0].summary ? story.body[0].summary :story.body[0].value.replace(/<[^>]+>/g, '').slice(0, 140) } />
					<meta property="og:title" content={story.title[0].value} />
					<meta property="og:image" content={story.field_news_image && story.field_news_image[0] && story.field_news_image[0].url} />
					<meta property="og:type" content="article" />
				</Helmet>
				<div className="news-article">
					<div className="image">
						<div>
							<img src={ story.field_news_image && story.field_news_image[0] && story.field_news_image[0].url } />
						</div>
						{ story.field_news_package_file[0] && <PlayMedia media={story.field_news_package_file[0].url} title={story.title[0].value} /> }
					</div>
					<div className="synopsis">
						{ live ? <div className="category">Live</div> : null }

						<h2>{story.title[0].value}</h2>
						<div className="created">{ DateTime.fromISO(story.created[0].value).toLocaleString(DateTime.DATE_HUGE) }
						</div>
						{author ? <div className="credit">by <span className="author">{author.author_name}</span></div> : null}
						<div dangerouslySetInnerHTML={ badmarkup } />
						<div className="clear" />
					</div>
					{ story.field_news_image.length > 1 && story.field_news_image.map( (item, i) => { if ( i != 0 ) {
						return (
							<div style={{ marginBottom: '1em'}} >
								<img style={{ width: '100%' }}src={ item.url } />
								<span style={{ fontSize: '80%'}}>{item.alt}</span>
							</div>
						)
					} else { return null }})
					}
					{ live && stories.articles[nid].live.map(l =>
						<div className="live-content" style={{ marginBottom: '2em' }}>
							<div className="created">{ DateTime.fromMillis(l.created[0].value).toRelative() }
							{/* <div className="created">{moment.unix(l.created[0].value).fromNow()} */}
							</div>
							<div style={{ paddingLeft: '1em', borderLeft: '1px solid #ccc' }}>
								<h2>{l.title[0].value}</h2>
								{l.body && l.body[0] && <div dangerouslySetInnerHTML={{ __html: l.body[0].value }}></div> }
							</div>
						</div>
					)}
					{ author ?
						<div className="contributor">
						<div>
							{ author.user_picture && <img style={{ float: 'left', marginRight: '10px' }} src={ '//jeff.4zzz.org.au/' + author.user_picture} />}
							<h4>{author.author_name}</h4>
							<div dangerouslySetInnerHTML={{ __html: author.author_bio }}></div>
						</div>
					 </div>
					: null}
				</div>

			</div>
	)
}

export default connect(state =>  ({ stories: state.stories } )) (Article)
